import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Books from './pages/Books';
import CorporateTraining from './pages/CorporateTraining';
import IndividualTraining from './pages/IndividualTraining';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import Contact from './pages/Contact';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Sitemap from './pages/Sitemap';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkinda" element={<About />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/kitaplar" element={<Books />} />
            <Route path="/kurumsal-egitimler" element={<CorporateTraining />} />
            <Route path="/bireysel-egitimler" element={<IndividualTraining />} />
            <Route path="/makaleler" element={<Articles />} />
            <Route path="/makaleler/:slug" element={<ArticleDetail />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/kullanim-sartlari" element={<TermsOfService />} />
            <Route path="/gizlilik" element={<PrivacyPolicy />} />
            <Route path="/site-haritasi" element={<Sitemap />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;